import React from 'react';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { MclHeader } from '@components/Header';
import SimpleFooter from '@components/SimpleFooter/SimpleFooter';
import styles from './MclLayout.module.scss';

interface ILayoutProps {
  children?: React.ReactNode;
}

export const MclLayout = ({ children }: ILayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mclLayout}>
      <Head>
        <title>{t('common:mijn-carellurvink.page-title')}</title>
      </Head>

      <div className={styles.header}>
        <MclHeader />
      </div>

      <main className={styles.main}>{children}</main>
      <div className={styles.footer}>
        <SimpleFooter />
      </div>
    </div>
  );
};
